module.exports = __webpack_public_path__ + "static/media/SVGOnlineTest.82f9f4c4.svg";